<div class="filters">
  <ssg-side-filter (apply)="applyEdits()" (reset)="clearEditFilters()" (toggle)="toggleFilters($event)" [isDisabled]="!editFilters" [isInvalid]="!editFilters || isWorking" class="flex-column">
    <div *ngIf="editFilters" class="flex-fill flex-column">
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="company_name_edit_label" translate>COMPANIES.FILTER_COMPANY_LABEL</div>
          <ssg-multi-select [items]="companiesDataSource" bindLabel="legalName" [multiple]="true" placeholder="{{ 'COMPANIES.SEARCH' | translate }}" [(ngModel)]="editFilters.companies" (search)="searchCompaniesByLegalName($event)" data-automation="company_name_select">
          </ssg-multi-select>
        </div>
      </div>

      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="company_code_edit_label" translate>COMPANIES.COMPANY_CODE_LABEL</div>
          <ssg-multi-select [items]="companyCodesDataSource" bindValue="integration.cmpCode" bindLabel="integration.cmpCode" [multiple]="true" placeholder="{{ 'COMPANIES.COMPANY_CODE_PLACEHOLDER' | translate }}" [(ngModel)]="editFilters.companyCodes" (search)="searchCompaniesByCompanyCode($event)" data-automation="company_code_select">
          </ssg-multi-select>
        </div>
      </div>

      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="fein_edit_label" translate>COMPANIES.FEIN_LABEL</div>
          <ssg-multi-select [items]="companyFeinsDataSource" bindValue="fein" bindLabel="fein" [multiple]="true" placeholder="{{ 'COMPANIES.FEIN_PLACEHOLDER' | translate }}" [(ngModel)]="editFilters.feins" (search)="searchCompaniesByFein($event)" data-automation="company_fein_select">
          </ssg-multi-select>
        </div>
      </div>

      <div class="wrap-container vertical-spacing flex-row flex-gap-5pct">
          
        <ukg-input-container [block]="true" [size]="medium">
            <div text-wrap data-automation="pay_group_edit_label" translate>COMPANIES.FILTER_PAY_GROUP_LABEL</div>
            <ukg-select data-automation="pay_group_edit_dropdown" placeholder="{{ 'COMPANIES.PAY_GROUP_PLACEHOLDER' | translate}}" [disabled]="!allPayGroups.length"
            [multiple]="true" searchPlaceholder="{{'COMPANIES.SEARCH' | translate}}" [(ngModel)]="editFilters.payGroups">
              <ukg-select-option *ngFor="let item of allPayGroups" [value]="item" [label]="item" ></ukg-select-option>
            </ukg-select>
        </ukg-input-container>
      </div>

      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div data-automation="fein_edit_label" class="prenoteFileSentLabel" translate>COMPANIES.PRENOTE_FILE_SENT_LABEL</div>
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true"
              [(ngModel)]="editFilters.prenoteFileSentYes" data-automation="prenote_file_sent_yes">
              <span translate>COMPANIES.YES</span>
            </ukg-checkbox> 
          
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true"
              [(ngModel)]="editFilters.prenoteFileSentNo" data-automation="prenote_file_sent_no">
              <span translate>COMPANIES.NO</span> 
            </ukg-checkbox>
        </div>
      </div>

    </div>
  </ssg-side-filter>
</div>
